import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation } from '@tanstack/react-query'

export type RecipientGroup =
  | 'LANDLORD'
  | 'USER'
  | 'ROOMMATE'
  | 'ONGOING_OFFER'

export type SendEmailPayload = {
  recipient_emails: string[]
  groups: RecipientGroup[]
  subject: string
  title: string
  message_text: string
  attachments?: File[]
}

type SendEmailResponse = {
  sent: number
}

export function useSendEmail() {
  const onError = useOnError()

  async function sendEmail(body: SendEmailPayload) {
    const formData = new FormData()
    body.recipient_emails.forEach((email) =>
      formData.append('recipient_emails', email)
    )
    body.groups.forEach((group) => formData.append('groups', group))
    formData.append('subject', body.subject)
    formData.append('title', body.title)
    formData.append('message_text', body.message_text)
    ;(body.attachments ?? []).forEach((file) =>
      formData.append('attachments', file)
    )

    const res = await apiClient.post<SendEmailResponse>(
      BACK_OFFICE_PREFIX + 'admin-email/send/',
      formData,
      // Override the client's default JSON content-type so axios sets
      // multipart/form-data with the correct boundary for the FormData body.
      { headers: { 'Content-Type': undefined } }
    )
    return res.data
  }

  return useMutation({
    mutationFn: sendEmail,
    onError
  })
}
